// src/styles/theme.ts - Исправленная версия с shadows
export const theme = {
  colors: {
    // Основные цвета бренда Geltek
    primary: '#7B68EE',        // Основной сиреневый
    primaryLight: '#9966CC',   // Светлый вариант сиреневого
    primaryDark: '#6366F1',    // Темный вариант сиреневого
    
    // Акцентные цвета
    accent: '#87CEEB',         // Светло-голубой
    accentLight: '#06B6D4',    // Циан
    accentDark: '#10B981',     // Мятный
    
    // Нейтральные цвета
    background: '#FFFFFF',     // Основной фон
    surface: '#F8FAFC',        // Поверхности (карточки)
    surfaceLight: '#F1F5F9',   // Светлые поверхности
    
    // Цвета текста
    text: {
      primary: '#0F172A',      // Основной текст
      secondary: '#334155',    // Вторичный текст
      tertiary: '#64748B',     // Третичный текст
      muted: '#94A3B8',        // Приглушенный текст
      inverse: '#FFFFFF',      // Белый текст
    },
    
    // Семантические цвета
    success: '#22C55E',        // Успех
    warning: '#F59E0B',        // Предупреждение
    error: '#EF4444',          // Ошибка
    info: '#3B82F6',           // Информация
    
    // Градиенты
    gradients: {
      primary: 'linear-gradient(135deg, #7B68EE 0%, #9966CC 100%)',
      accent: 'linear-gradient(135deg, #87CEEB 0%, #06B6D4 100%)',
      success: 'linear-gradient(135deg, #22C55E 0%, #10B981 100%)',
      sunset: 'linear-gradient(135deg, #FF6B6B 0%, #FFE66D 100%)',
      ocean: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    },
    
    // Темная тема (для Telegram)
    dark: {
      background: '#1A1A1A',
      surface: '#2D2D2D',
      text: '#FFFFFF',
      textSecondary: '#A0A0A0',
    },
    
    // Границы и разделители
    border: {
      light: '#E2E8F0',
      default: '#CBD5E1',
      dark: '#475569',
    },
  },
  
  // 🔧 ИСПРАВЛЕНО: Добавляем тени (shadows)
  shadows: {
    sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    default: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
    md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
    xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
  },
  
  // Размеры шрифтов
  fontSize: {
    xs: '0.75rem',    // 12px
    sm: '0.875rem',   // 14px
    base: '1rem',     // 16px
    lg: '1.125rem',   // 18px
    xl: '1.25rem',    // 20px
    '2xl': '1.5rem',  // 24px
    '3xl': '1.875rem',// 30px
    '4xl': '2.25rem', // 36px
    '5xl': '3rem',    // 48px
  },
  
  // Толщина шрифтов
  fontWeight: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },
  
  // Пространства и отступы
  spacing: {
    xs: '0.25rem',   // 4px
    sm: '0.5rem',    // 8px
    md: '1rem',      // 16px
    lg: '1.5rem',    // 24px
    xl: '2rem',      // 32px
    '2xl': '3rem',   // 48px
    '3xl': '4rem',   // 64px
  },
  
  // Радиусы скругления
  borderRadius: {
    none: '0',
    sm: '0.125rem',   // 2px
    default: '0.25rem', // 4px
    md: '0.375rem',   // 6px
    lg: '0.5rem',     // 8px
    xl: '0.75rem',    // 12px
    '2xl': '1rem',    // 16px
    '3xl': '1.5rem',  // 24px
    full: '9999px',   // Полное скругление
  },
  
  // Точки останова для адаптивности
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
  
  // Z-индексы
  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modal: 1040,
    popover: 1050,
    tooltip: 1060,
    toast: 1070,
  },
  
  // Переходы и анимации
  transitions: {
    fast: '0.15s ease',
    normal: '0.3s ease',
    slow: '0.5s ease',
    
    // Специфические переходы
    button: '0.2s ease',
    modal: '0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    slide: '0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  },
  
  // Эффекты для Telegram Web App
  haptic: {
    light: 'light',
    medium: 'medium',
    heavy: 'heavy',
    soft: 'soft',
    rigid: 'rigid',
  },
};

// Типы для TypeScript
export type Theme = typeof theme;

// Расширяем модуль styled-components для типизации
declare module 'styled-components' {
  export interface DefaultTheme extends Theme {}
}